<template>
  <div class="mainContent">
    <div class="apply">
      <h3 class="apply-underline">
        <p class="apply-secondTitle">
          特许经营商申请表
        </p>
      </h3>
      <div class="apply-mainText">
        <div class="form">
          <form name="form" id="fm">
            <div class="apply-form-head">注：填表人必须确保以下信息均属真实，如发现有虚假信息，本公司有权作出相应法律措施。</div>

            <table>
              <tbody>
                <tr>
                <td width="40">姓名</td>
                <td width="135"><input type="text" v-model="form.name" name="username" size="10" placeholder="您的名字"></td>
                <td width="40">性别</td>
                <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.sex == 1}" @click="change('sex', 1)">男</span></td>
                <td width="120"><span class="selectBtn" :class="{'selectBtnPress': form.sex == 2}" @click="change('sex', 2)">女</span></td>
                <td width="40">证件</td>
                <td><input type="text" v-model="form.idCard" name="cart" size="25" placeholder="身份证号码"></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="40">手机</td>
                  <td width="230"><input type="text" id="phone" v-model="form.mobilePhone" @input="handleInput('mobilePhone', $event)" size="20" class="inp" name="mobile" maxlength="11"></td>
                  <td width="40">座机</td>
                  <td width="179"><input type="text" v-model="form.telephone" size="15" class="inp" name="phone" ></td>
                  <td width="40">传真</td>
                  <td><input type="text" size="15" v-model="form.fax" class="inp" name="portraiture" ></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="70">通讯地址</td>
                  <td width="200"><input type="text" v-model="form.communicateAddress" size="20" class="inp" name="address"></td>
                  <td width="40">邮编</td>
                  <td width="154"><input type="text" id="postCode" v-model="form.zipcode" @input="handleInput('zipcode', $event)" size="10" class="inp" name="postCode"></td>
                  <td width="50">E-mail</td>
                  <td><input type="text" size="17" v-model="form.email" class="inp" name="email" ></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="80">投资者身份</td>
                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.identity == 1}" @click="change('identity',1)">个人</span></td>
                  <td width="110"><span class="selectBtn" :class="{'selectBtnPress': form.identity == 2}" @click="change('identity',2)">企业</span></td>
                  <td width="60">授权方式</td>

                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.style == 1}" @click="change('style',1)">独立</span></td>
                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.style == 2}" @click="change('style',2)">合伙</span></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="120">是否从事餐饮行业</td>

                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.doFoodBusiness}" @click="change('doFoodBusiness', true)">是</span></td>
                  <td width="120"><span class="selectBtn" :class="{'selectBtnPress': !form.doFoodBusiness}" @click="change('doFoodBusiness', false)">否</span></td>
                  <td width="140">现有资产是否&gt;400万</td>

                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': form.assetsPassFourMillion}" @click="change('assetsPassFourMillion', true)">是</span></td>
                  <td width="35"><span class="selectBtn" :class="{'selectBtnPress': !form.assetsPassFourMillion}" @click="change('assetsPassFourMillion', false)">否</span></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="140">可投入加盟资金:RMB</td>
                  <td width="200"><input type="text" placeholder="仅限输入数字" size="20" id="fund" v-model="form.affiliateFunds" @input="handleInput('affiliateFunds', $event)" class="inp" name="fund"></td>
                  <td width="120">欲在何地投资加盟</td>
                  <td><input type="text" size="20" v-model="form.affiliateAddress" class="inp"  name="city" ></td>
                </tr>
              </tbody>
            </table>

            <table>
              <tbody>
                <tr>
                  <td width="70">联系地址</td>
                  <td width="100"><input type="text" size="40" v-model="form.contactadd" ></td>
                </tr>
              </tbody>
            </table>

            <table width="100%">
              <tbody>
                <tr>
                  <td width="115" style="vertical-align: top;">
                    <span>自身能力和优势</span>
                  </td>
                  <td>
                    <textarea class="inp" cols="80" v-model="form.abilityAndAdvantage" style="width: 100%;" rows="5" name="ability" id="youshi" ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>

            <table width="100%">
              <tbody>
                <tr>
                  <td width="800">本人申请成为北京棒约翰餐饮管理有限公司加盟商，望能批准！</td>
                </tr>
              </tbody>
            </table>

            <table width="100%">
              <tbody>
                <tr>
                  <td width="50">填表人</td>
                  <td><input type="text" v-model="form.preparer" size="10" class="inp" name="applicant" ></td>
                  <td width="65">填表日期</td>
                  <td><input type="date" v-model="form.sheetDate" size="12" class="inp" name="date" ></td>
                </tr>
                <tr>
                  <td colspan="6" align="center">
                    <a @click="submitApply" href="javascript:void(0)">
                      <img :src="btnImg"/>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const btnImg = require('@/assets/image/info/tjsq1.jpg');

// const isEmail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
const isEmail = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/; // 邮箱正则

const isPhone = /^(\d{8}|\d{11})$/; // 手机号码正则

const isFound = /^\d*\.{0,1}\d{0,2}$/; // 金额正则

export default {
  name: 'root-application',
  data() {
    return {
      btnImg,
      form: {
        // 在线申请加盟
        name: '',
        idCard: '',
        mobilePhone: '',
        telephone: '',
        fax: '', // 传真
        communicateAddress: '',
        zipcode: '', // 邮政编码
        email: '',
        affiliateFunds: '',
        affiliateAddress: '',
        abilityAndAdvantage: '',
        preparer: '',
        sheetDate: '',
        contactadd: '',
        sex: '1', // 男
        identity: 1, // 投资人身份 个人 企业
        style: 1, // 独立 合伙
        doFoodBusiness: true, // 是否餐饮行业
        assetsPassFourMillion: true, // 资产是否大于400万
      },
    };
  },
  methods: {
    change(name, value) {
      if (!name) {
        return;
      }
      this.form[name] = value;
    },
    submitApply() {
      if (!this.filterForm()) {
        return;
      }
      this.$service.user.affiliateAdd({ content: this.form }).then((result) => {
        if (result.status !== 1) {
          return;
        }
        this.$Modal.info({
          name: '提示',
          content: '申请成功',
        });
      }).catch((err) => {
        if (err.msg) {
          this.$Modal.info({
            name: '提示',
            content: err.msg,
          });
        }
      });
    },
    filterForm() {
      let cont = '';
      let isEmpty = true;

      if (isEmpty && !this.form.idCard) {
        cont = '证件填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.name) {
        cont = '姓名填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.mobilePhone) {
        cont = '手机填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !isPhone.test(this.form.mobilePhone)) {
        cont = '手机填写不正确!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.telephone) {
        cont = '座机填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.fax) {
        cont = '传真填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.communicateAddress) {
        cont = '通讯地址填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.zipcode) {
        cont = '邮编填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.email) {
        cont = 'E-mail填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !isEmail.test(this.form.email)) {
        cont = 'E-mail填写不正确!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.affiliateFunds) {
        cont = '加盟资金填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !isFound.test(this.form.affiliateFunds)) {
        cont = '加盟资金填写不正确!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.affiliateAddress) {
        cont = '欲在何地投资加盟填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.contactadd) {
        cont = '联系地址填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.abilityAndAdvantage) {
        cont = '自身能力和优势填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.preparer) {
        cont = '填表人填写不能为空!';
        isEmpty = false;
      }
      if (isEmpty && !this.form.sheetDate) {
        cont = '填表日期填写不能为空!';
        isEmpty = false;
      }

      if (!isEmpty) {
        this.$Modal.info({
          name: '提示',
          content: cont,
        });
      }


      return isEmpty;
    },
    handleInput(name, e) {
      if (name === 'affiliateFunds') {
        if (!isFound.test(this.form[name])) {
          this.form[name] = this.form[name].substring(0, this.form[name].length - 1);
        }
        this.form[name] = this.form[name].replace(/^(0.0+)|[^\d.]+/g, '');
      } else {
        this.form[name] = e.target.value.replace(/[^\d]/g, '');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.apply-underline {
  height: 70px;
  position: relative;
}
.apply-secondTitle {
  font-size: 20px;
  color: #fff;
  width: 100%;
  height: 70px;
  line-height: 68px;
  background: url(../../../assets/image/info/introduce.png) 0 0 repeat;
  background-position: 0 -72px;
  background-size: 768px;
  text-align: center;
}
.apply-mainText {
  width: 100%;
  min-height: 346px;
  overflow: hidden;
  background: #f2f2f2;
  margin-top: -5px;
}

.form {
  padding: 10px 20px;
}
.apply-form-head {
  color: #ad0f14;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  height: 35px;
}
.form td {
  line-height: 33px;
  font-size: 13px;
  padding: 5px;
  margin-left: 0px;
  padding-left: 0px;
}
.selectBtn {
  border: 1px solid #c2c2c2;
  width: 70px;
  display: inline-block;
  line-height: 24px;
  text-align: center;
  background: #EBEBEB;
  border-radius: 10px;
  cursor: pointer;
  // 禁止选中
  -webkit-touch-callout: none; /* iOS Safari */

  -webkit-user-select: none; /* Chrome/Safari/Opera */

  -khtml-user-select: none; /* Konqueror */

  -moz-user-select: none; /* Firefox */

  -ms-user-select: none; /* Internet Explorer/Edge */

  user-select: none;
}
.selectBtnPress {
  color: #fff;
  background:#009774;
}
.form input.text,.form select,.form textarea,.form .singleField,.form input[type="text"] {
  background: none 0 0 repeat-x #fff;
  float: left;
  border: 1px solid #ccc;
  padding: 3px;
  color: #666;
}
</style>
